"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createApiPdfInvoiceRepo = createApiPdfInvoiceRepo;
const HTTPClient_1 = require("../../../common/api/HTTPClient");
const http_helpers_1 = require("../../../common/api/http-helpers");
const PdfInvoiceMapper_1 = require("./mappers/PdfInvoiceMapper");
const getApiUrl_1 = require("../../../common/api/utils/getApiUrl");
function createApiPdfInvoiceRepo() {
    return {
        getById,
    };
}
async function getById(orderId) {
    try {
        const res = await HTTPClient_1.HTTPClient.get({
            url: (0, getApiUrl_1.getApiUrl)(`/v1/orders/${orderId}/invoices`),
        });
        (0, http_helpers_1.sendSuccessStatus)();
        return res.map(PdfInvoiceMapper_1.mapToDomainPdfInvoice);
    }
    catch (error) {
        console.log('error', error);
        (0, http_helpers_1.handleError)(error);
        return [];
    }
}
